import React, { useEffect, useState } from 'react';
import { Container, Typography, CircularProgress, Box, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import config from '../../config';
import { getSupportedLanguageId } from '../../i18n/helper';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
        },
        container: {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(4),
        },
    }),
);

export default function HelpPage() {
    const classes = useStyles();
    const { t, i18n } = useTranslation('common');
    const [markdownContent, setMarkdownContent] = useState<string>('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const language = getSupportedLanguageId(i18n.language);
        const url = `${config.docsBaseUrl}/${language}/getting-started.md`;

        setLoading(true);
        setError(false);

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch: ${response.status}`);
                }
                return response.text();
            })
            .then(text => {
                setMarkdownContent(text);
                setLoading(false);
            })
            .catch(() => {
                setError(true);
                setLoading(false);
            });
    }, [i18n.language]);

    return (
        <main className={classes.content}>
            <Container maxWidth="md" className={classes.container}>
                {loading && (
                    <Box display="flex" justifyContent="center" mt={4}>
                        <CircularProgress />
                    </Box>
                )}
                {error && (
                    <Typography color="error">{t('help.loadError')}</Typography>
                )}
                {!loading && !error && (
                    <Markdown skipHtml>{markdownContent}</Markdown>
                )}
            </Container>
        </main>
    );
}
